import React from 'react';
import { cn } from './utils';

export function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn("animate-pulse rounded-xl bg-gradient-to-r from-surface-100 via-surface-200 to-surface-100", className)}
      {...props}
    />
  );
}